import React from 'react';
import classNames from 'classnames';
/**
 * Bronson StatusMessage component.
 * StatusMessage communicates a status with icon and text. It includes
 * default statuses like `info`, `success`, `warning` and `error`.
 * The icon is set automatically depending on the status.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-status-message.html
 * @constructor
 */
export function StatusMessage({ className, label, status = null, testId, ...otherProps }) {
    const classNameList = classNames('c-status-message', {
        [`c-status-message--${status} `]: status,
    }, className).trim();
    return (React.createElement("div", { className: classNameList, "data-testid": testId, ...otherProps }, label));
}
